import * as z from 'zod';
import { CURRENCY } from 'src/types';

export type ServicePlanTermFormSchemaValues = z.infer<typeof servicePlanTermFormSchema>;
export const servicePlanTermFormSchema = z.object({
    valid_from: z.string(),
    currency: z.enum(CURRENCY),
    valid_to: z.string().optional().nullable(),
    trial_period_days: z.number().int().optional().nullable(),
    unpaid_grace_period_days: z.number().int().optional().nullable(),
    lock_warning_days: z.number().int().optional().nullable(),
    lock_grace_period_days: z.number().int().optional().nullable(),
    stop_warning_days: z.number().int().optional().nullable(),
    stop_grace_period_days: z.number().int().optional().nullable(),
});

export type PatchServicePlanTermFormSchemaValues = z.infer<typeof patchServicePlanTermFormSchema>;
export const patchServicePlanTermFormSchema = servicePlanTermFormSchema.partial();
